import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { HorizontalStack, SmartContainer, Stack, Surface } from '../../../styles/Containers';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { AssetCard } from './AssetCard';
import { ImageCroppingPresets } from '../../../modules/Media/MediaUtils';
import { animated } from 'react-spring';
import { TERM_ALBUM_PLURAL, TERM_LIBRARY, TERM_LIBRARY_PLURAL, useAnimatedAssetSelection } from '../../services/CaptureCollabService';
import { FullAssets } from './redux/assets.selectors';
import { IconDownload, IconFavoriteFilled, IconFavoriteOutlined, IconNext, IconPrev, IconSaveFilled, IconSaveOutlined } from '../../Icons';
import { TagEditor } from '../../../components/Taxonomy/TagEditor';

import { FullLibraries } from '../Library/redux/library.selectors';
import { searchLibrary, replaceLibraryTags } from '../Library/redux/library.actions';

import { FullLocations } from '../Location/redux/locations.selectors';
import { searchLocations, replaceLocationTags } from '../Location/redux/locations.actions';

import { FullPeople } from '../People/redux/people.selectors';
import { searchPeople, replacePeopleTags } from '../People/redux/people.actions';

import { FullGenericTags } from '../GenericTags/redux/generictags.selectors';
import { searchGenericTags, replaceGenericTags } from '../GenericTags/redux/generictags.actions';
import { StyledB, StyledP } from '../../../styles/StyledHTML';
import { StyledSwitch } from '../../../styles/matieralui/Form';
import { StyledButton } from '../../../styles/matieralui/Button';
import { Divider } from '@mui/material';
import { AssetDownloadButton } from './AssetDownloadButton';
import { InlineTextInput } from '../../../components/Forms/InlineTextInput';
import { useDispatch } from 'react-redux';
import { deleteAsset, updateAsset } from './redux/assets.actions';
import { FormInput } from '../../../components/Forms/FormInput';
import { Like } from '../UserEngagement/Like';
import { Save } from '../UserEngagement/Save';
import { TotalEngagement } from '../UserEngagement/TotalEngagement';
import { FullAlbums } from '../Album/redux/album.selectors';
import { replaceAlbumTags, searchAlbum } from '../Album/redux/album.actions';
import { StyledTab, StyledTabs, StyledTabPanel } from '../../../styles/matieralui/Tabs';
import { Comments } from '../Comments/Comments';
import { Role } from '../../../redux/Auth/auth.selectors';
import { useMyPermissions } from '../Permission/redux/permissions.actions';
import { NoPermissions } from '../Permission/NoPermissions';
import { respondTo, Theme } from '../../../styles/Theme';
import moment from 'moment';
import { DateTimePicker } from '../../../components/Forms/DatePicker';
import { MoveToTrash } from '../../../components/Publishing/MoveToTrash';
import { useKeyPress } from '../../../services/Utils';
import { TagEditorWithAutoComplete } from '../../../components/Taxonomy/TagEditorWithAutoComplete';
import { AssetEngagement } from './AssetEngagement';
import { Repeater } from '../../../components/Forms/Repeater';
import { MediaFormInput } from '../../../modules/Media/MediaFormInput';
import { MediaPreviewAsText } from '../../../modules/Media/MediaPreview';


export const StyleTopContainer = styled(SmartContainer)`
    width: 100%;
    border-bottom: ${Theme.borderWidth} solid ${Theme.colors.dark};
    padding: 1em;
    height: 70px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    [data-controls]{
        display: flex;
        justify-content: flex-end;
    }
    ${respondTo('mobile', css`
        display: flex;
        flex-direction: column;
        height: auto;
        justify-content: flex-start;
        [data-name-editor]{
            order: 2;
            margin-top: 1em;
            width: 100%;
            border-top: ${Theme.borderWidth} solid ${Theme.colors.dark};
            padding-top: 1em;
        }
        [data-controls]{
            
            display: flex;
            justify-content: flex-end;
            order: 1;
            width: 100%;
        }
    `)}
`

export const StyleBottomContainer = styled(SmartContainer)`
    width: 100%;
    border-top: ${Theme.borderWidth} solid ${Theme.colors.dark};
    padding: 1em;
    height: 70px;
    ${respondTo('mobile', css`
        position: fixed;
        bottom: 0;
        left: 0;
        z-index: 5;
        background-color: ${Theme.colors.base};
    `)};
`

export const StyledAssetContainer = styled(SmartContainer)`

    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    ${respondTo('mobile', css`
        height: calc(100vh - 70px);
    `)};
`

export const StyledAssetPreview = styled(SmartContainer)`

`

export const StyledBody = styled(SmartContainer)`
    display:flex;
    flex: 1;
    overflow: auto;
    max-height: 100vh;
    width: 100%;

    
    [data-asset]{
        flex:2;
        padding: 2em;

        display: flex;
        align-items: center;
        justify-content: center;
        overflow: auto;
    }
    [data-right-bar]{
        flex:1;
        padding: 2em;
        padding-top: 0;
        border-left: ${Theme.borderWidth} solid ${Theme.colors.dark};
        overflow: auto;
        max-height: 100vh;
    }
    img {
        object-fit: contain;
        max-height: 80vh;
    }
    ${respondTo('mobile', css`
       display: block;
       max-height: none;
       [data-right-bar]{
            border-left: 0px;
            max-height: none;
       }
    `)}
`
const StyledWorkingFile = styled(MediaFormInput)`
    [data-clear-button],
    [data-label] { display: none; }
    button {
        margin-bottom: 0 !important;
    }
`

const AssetWorkingFile = ({ item, onChange }) => {
    const [type, setType] = useState(null);
    useEffect(() => {
        if (!item) return;
        if (item?.url) setType('url')
    }, [item?.url])
    return (
        <Surface width="100%">
            <HorizontalStack flex align="center">
                {/* <FormInput label="Name" value={item.name} onChange={(value) => onChange(item, 'name', value)} /> */}



                {type !== 'url' && (<StyledWorkingFile display="text" label="" buttonText="Select File" value={item.src} onChange={(value) => onChange(item, 'src', value)} />)}
                {type !== 'url' && !item?.src && (<StyledButton variant='outlined' onClick={() => setType('url')}>External URL</StyledButton>)}
                {type === 'url' && (<FormInput label="Name" value={item?.name} onChange={(value) => onChange(item, 'name', value)} />)}
                {type === 'url' && (<FormInput label="URL" value={item?.url} onChange={(value) => onChange(item, 'url', value)} />)}
            </HorizontalStack>
        </Surface>
    )
}





export const AssetViewer = ({ asset, onClose, setAssetByIndex = null }) => {

    const { animatedProps } = useAnimatedAssetSelection();
    const [editMode, setEditMode] = useState(false);
    const store = FullAssets();
    const storeTags = FullGenericTags();
    const storePeople = FullPeople();
    const storeLocations = FullLocations();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(0);
    const handleTabChange = (event, index) => setActiveTab(index);


    const leftArrow = useKeyPress("ArrowLeft")
    const rightArrow = useKeyPress("ArrowRight")
    const escape = useKeyPress("Escape");



    // Editable Fields
    const [name, setName] = useState(null);
    const [content, setContent] = useState(null);
    const [capturedDate, setCapturedDate] = useState(null);
    const [genericTags, setGenericTags] = useState(null);
    const [people, setPeople] = useState(null);
    const [locations, setLocations] = useState(null);
    const [albums, setAlbums] = useState(null);
    const [libraries, setLibraries] = useState(null);
    const [needsRefresh, setNeedsRefresh] = useState(false);
    const [workingFiles, setWorkingFiles] = useState([])
    const [coverPhoto, setCoverPhoto] = useState(null);


    // Permissions
    const fullLibraries = FullLibraries();
    const currentUserRole = Role();
    const { permissions, hasPermission, getPermissionRole, permissionChecked, setChecking } = useMyPermissions();
    const [noAccess, setNoAccess] = useState(true);
    const [myRole, setMyRole] = useState(null);

    // const libraryKey = `libkey_${asset?.id}`;
    const libraryKey = `libpermissionscheck`;

    const loadLibraryForAsset = () => {
        // Get Librarys For This Asset
        const args = {}
        args.Asset = asset.id;
        args['prefix'] = libraryKey;
        if (!fullLibraries[libraryKey]?.rows) {
            dispatch(searchLibrary(0, null, null, 'all', args));
        }
    }

    useEffect(() => {
        // Load Library for Permission Check.
        // We dont check on every asset because we check before the asset list is shown.
        loadLibraryForAsset();
        setChecking('notchecked');
    }, [])

    useEffect(() => {
        if (asset?.name) setName(asset.name);
        else setName('');

        if (asset?.content) setContent(asset.content);
        else setContent('');

        if (asset?.capturedDate) setCapturedDate(asset?.capturedDate);
        else setCapturedDate(null)

        if (asset?.meta?.attachments) setWorkingFiles(asset?.meta.attachments);
        else setWorkingFiles([])

        if (asset?.meta?.coverPhoto) setCoverPhoto(asset.meta.coverPhoto);
        else setCoverPhoto('');

        // Clear Tags
        setGenericTags(null);
        setPeople(null);
        setLocations(null);
        setAlbums(null);
        setLibraries(null);



    }, [asset?.id])

    // Check Permissions
    useEffect(() => {


        if (!fullLibraries[libraryKey]) return;

        if (fullLibraries[libraryKey]?.rows?.length === 0) {
            const canViewLibrary = hasPermission('Library', null);
            if (canViewLibrary) {
                const r = getPermissionRole('Library', null);
                setNoAccess(false);
                setMyRole(r);
            }
        }

        // Check permissions for each Tag.
        const res = fullLibraries[libraryKey]?.rows?.map(library => {
            const canViewLibrary = hasPermission('Library', library.id);
            if (canViewLibrary) {
                const r = getPermissionRole('Library', library.id);
                setNoAccess(false);
                setMyRole(r);
            }
        })


    }, [permissions, fullLibraries[libraryKey]?.rows?.length])

    useEffect(() => {

        // If We are Editing, Turn this off.
        if (editMode) return false;


        // Left & Right
        if (leftArrow === true) prev();
        if (rightArrow === true) next();
    }, [leftArrow, rightArrow])

    useEffect(() => {

        if (escape === true) {
            onClose();
        }
    }, [escape])

    const handleDeleteSuccess = (item) => {
        onClose();
    }


    const handleToggleEdit = () => {
        setEditMode(!editMode)
    }

    const next = () => {
        if (!store.items) return;
        if (store?.items?.count <= 1) return;
        let nextIndex = 0;
        const current = store.items.rows.find((item, index) => {
            if (item?.id === asset?.id) {
                nextIndex = index + 1;
                return item;
            }
        })

        if (nextIndex >= store.items.count) nextIndex = 0;
        setAssetByIndex(nextIndex);

    }

    const prev = () => {
        if (!store.items) return;
        if (store?.items?.count <= 1) return;

        let prevIndex = 0;
        const current = store.items.rows.find((item, index) => {
            if (item?.id === asset?.id) {
                prevIndex = index - 1;
                return item;
            }
        })

        if (prevIndex < 0) prevIndex = (store.items.count - 1);

        setAssetByIndex(prevIndex);
    }


    const handleSubmit = () => {

        // clone Meta
        const meta = { ...asset.meta }
        meta.attachments = workingFiles;
        meta.coverPhoto = coverPhoto;

        // Payload
        const payload = {
            name,
            content: (content) ? content : ' ',
            meta,
            capturedDate
        }
        dispatch(updateAsset(asset.id, payload));

        // Save Tags
        if (genericTags !== null) dispatch(replaceGenericTags(genericTags, "Asset", asset.id))
        if (people !== null) dispatch(replacePeopleTags(people, "Asset", asset.id))
        if (locations !== null) dispatch(replaceLocationTags(locations, "Asset", asset.id))
        if (albums !== null) dispatch(replaceAlbumTags(albums, "Asset", asset.id))
        if (libraries !== null) dispatch(replaceLibraryTags(libraries, "Asset", asset.id))
        setNeedsRefresh(true);
        setTimeout(() => setNeedsRefresh(false), 2000)
    }


    useEffect(() => {

        if (store.updateSuccess) {
            setEditMode(false)
        }
        if (store.updateError) {
            setEditMode(false)
        }

    }, [store.updateLoading])

    const renderNavigation = () => {
        if (!store.items) return;
        if (store?.items?.count <= 1) return null;
        if (!setAssetByIndex) return null;

        return (
            <StyleBottomContainer flex align="center" justify="center">
                <StyledIconButton onClick={prev}><IconPrev /></StyledIconButton>
                <StyledIconButton onClick={next}><IconNext /></StyledIconButton>
            </StyleBottomContainer>
        )
    }


    const repeaterOnChange = (updatedData) => {
        setWorkingFiles([...updatedData]);
    }

    if (noAccess || permissionChecked === 'notchecked') return (
        <animated.div style={animatedProps}>
            <NoPermissions checked={permissionChecked} />
        </animated.div>
    )


    const isAtLeastAnAdmin = (currentUserRole === 'owner' || currentUserRole === 'admin');
    let adminEditable = false;
    if (isAtLeastAnAdmin && editMode === true) adminEditable = true;



    return (
        <animated.div style={animatedProps}>
            <StyledAssetContainer data-asset-container>
                <StyleTopContainer>
                    <SmartContainer data-name-editor>
                        <InlineTextInput disabled={!editMode} label="Name" value={name} onChange={setName}>
                            {name}
                        </InlineTextInput>

                    </SmartContainer>
                    <SmartContainer data-controls>
                        {!editMode && myRole !== 'viewer' && (<StyledButton onClick={() => setEditMode(true)}>Edit</StyledButton>)}

                        {editMode && (<StyledButton variant='contained' color="blue" onClick={handleSubmit}>Save</StyledButton>)}
                        <AssetDownloadButton asset={asset} />
                        {!editMode && myRole !== 'viewer' && (<MoveToTrash id={asset.id} action={deleteAsset} selector={FullAssets} onSuccess={handleDeleteSuccess} icon={true} />)}


                        <StyledIconButton onClick={onClose}><CloseIcon /></StyledIconButton>
                    </SmartContainer>
                </StyleTopContainer>
                <StyledBody>
                    <SmartContainer data-asset>
                        <SmartContainer >
                            <AssetCard item={asset} crop={ImageCroppingPresets.preview} noControls={true} />
                            <AssetEngagement modelId={asset.id} modelType="Asset" />

                        </SmartContainer>
                    </SmartContainer>
                    <SmartContainer data-right-bar>
                        <StyledTabs variant="fullWidth" centered indicatorColor="primary" value={activeTab} onChange={handleTabChange} aria-label="Edit Form" scrollButtons="auto">
                            <StyledTab label="Info" id="screen-1" key="screen-1" aria-controls="screen-1" />
                            <StyledTab label="Tags" id="screen-2" key="screen-2" aria-controls="screen-2" />
                            <StyledTab label="Stats" id="screen-3" key="screen-3" aria-controls="screen-3" />
                            {/* {myRole !== 'viewer' && (<StyledTab label="Comments" id="screen-2" key="screen-2" aria-controls="screen-2" />)} */}
                        </StyledTabs>
                        <StyledP>&nbsp;</StyledP>
                        <StyledTabPanel value={activeTab} index={0}>
                            <Stack>
                                <Stack>
                                    <StyledP small><StyledB>Name</StyledB></StyledP>
                                    <InlineTextInput disabled={!editMode} label="Name" value={name} onChange={setName}>{name}</InlineTextInput>
                                </Stack>

                                <Divider />

                                {!editMode && (
                                    <Stack>
                                        <StyledP small><StyledB>Caption</StyledB></StyledP>
                                        <SmartContainer>{content}</SmartContainer>
                                    </Stack>
                                )}
                                {editMode && (
                                    <Stack>
                                        <StyledP small><StyledB>Caption</StyledB></StyledP>
                                        <FormInput label="Caption" value={content} onChange={setContent} multiline />
                                    </Stack>
                                )}
                                <Divider />
                                {!editMode && (
                                    <Stack>
                                        <StyledP small><StyledB>Captured: </StyledB> {moment(asset?.capturedDate).format('YYYY-MM-DD')}</StyledP>
                                        <StyledP small><StyledB>Uploaded: </StyledB> {moment(asset?.createdAt).format('YYYY-MM-DD')}</StyledP>
                                        {asset?.meta?.exif?.Make && (<StyledP small><StyledB>Make: </StyledB> {asset.meta.exif.Make}</StyledP>)}
                                        {asset?.meta?.exif?.Model && (<StyledP small><StyledB>Model: </StyledB> {asset.meta.exif.Model}</StyledP>)}
                                        {asset?.meta?.exif?.lens && (<StyledP small><StyledB>Lens: </StyledB> {asset.meta.exif.lens}</StyledP>)}
                                        {asset?.meta?.exif?.Copyright && (<StyledP small><StyledB>Copyright: </StyledB> {asset.meta.exif.Copyright}</StyledP>)}
                                        {asset?.meta?.exif?.creator && (<StyledP small><StyledB>Creator: </StyledB> {asset.meta.exif.creator}</StyledP>)}
                                    </Stack>
                                )}
                                {editMode && (
                                    <Stack>
                                        <StyledP><StyledB>Capture</StyledB></StyledP>
                                        <DateTimePicker label="Captured" value={capturedDate} onChange={setCapturedDate} />
                                    </Stack>
                                )}
                                <Divider />
                                {!editMode && (
                                    <Stack>
                                        <StyledP small><StyledB>Additional Files: </StyledB></StyledP>
                                        {workingFiles?.map(i => {

                                            if (i?.src) return (<MediaPreviewAsText id={i?.src} />)
                                            if (i?.url) return (
                                                <SmartContainer flex align="center" justify="space-between">
                                                    <StyledP small ellipsis>{i?.name}</StyledP>
                                                    <StyledP small light><a small href={i?.url} target="_blank"><IconDownload /></a></StyledP>
                                                </SmartContainer>
                                            )
                                        })}
                                    </Stack>
                                )}
                                {adminEditable && (
                                    <Stack>
                                        <StyledP small><StyledB>Additional Files: </StyledB></StyledP>
                                        <Repeater
                                            id="workingfiles"
                                            datasource={workingFiles}
                                            component={AssetWorkingFile}
                                            onChange={repeaterOnChange}
                                            buttonText="New Working File"
                                        />
                                    </Stack>
                                )}
                                <Divider />
                                {adminEditable && asset?.mediaType === 'video' && (
                                    <Stack>
                                        <StyledP small><StyledB>Video Cover Photo: </StyledB></StyledP>
                                        <MediaFormInput type='image' label="" buttonText="Select File" value={coverPhoto} onChange={setCoverPhoto} />
                                    </Stack>
                                )}

                            </Stack>
                        </StyledTabPanel>

                        <StyledTabPanel value={activeTab} index={1}>
                            <Stack>


                                <StyledB small>{TERM_LIBRARY_PLURAL}</StyledB>

                                <TagEditorWithAutoComplete
                                    formLabel={`Search for ${TERM_LIBRARY}`}
                                    model="Asset"
                                    modelId={asset.id}
                                    selector={FullLibraries}
                                    action={searchLibrary}
                                    onChange={setLibraries}
                                    disabled={!adminEditable}
                                    refresh={needsRefresh} />

                                <StyledB small>{TERM_ALBUM_PLURAL}</StyledB>

                                <TagEditorWithAutoComplete
                                    formLabel={`Search for ${TERM_ALBUM_PLURAL}`}
                                    model="Asset"
                                    modelId={asset.id}
                                    selector={FullAlbums}
                                    action={searchAlbum}
                                    onChange={setAlbums}
                                    disabled={!adminEditable}
                                    refresh={needsRefresh} />

                                <StyledB small>Locations</StyledB>

                                <TagEditorWithAutoComplete
                                    formLabel="Search Locations"
                                    model="Asset"
                                    modelId={asset.id}
                                    selector={FullLocations}
                                    action={searchLocations}
                                    onChange={setLocations}
                                    disabled={!editMode}
                                    refresh={needsRefresh}
                                    staticOptions={storeLocations?.fulldataset?.rows} />

                                <StyledB small>People</StyledB>

                                <TagEditorWithAutoComplete
                                    formLabel="Search People"
                                    model="Asset"
                                    modelId={asset.id}
                                    selector={FullPeople}
                                    action={searchPeople}
                                    onChange={setPeople}
                                    disabled={!editMode}
                                    refresh={needsRefresh}
                                    staticOptions={storePeople?.fulldataset?.rows} />

                                <StyledB small>Tags</StyledB>

                                <TagEditorWithAutoComplete
                                    formLabel="Search Tags"
                                    model="Asset"
                                    modelId={asset.id}
                                    selector={FullGenericTags}
                                    action={searchGenericTags}
                                    onChange={setGenericTags}
                                    disabled={!editMode}
                                    refresh={needsRefresh}
                                    staticOptions={storeTags?.fulldataset?.rows} />

                            </Stack>
                        </StyledTabPanel>

                        {/* <StyledTabPanel value={activeTab} index={2}>
                            {myRole !== 'viewer' && (<Comments asset={asset} />)}
                            {myRole === 'viewer' && (<SmartContainer>No Access</SmartContainer>)}
                        </StyledTabPanel> */}

                        <StyledTabPanel value={activeTab} index={2}>
                            <Stack>
                                <StyledP small><StyledB>Captured: </StyledB>{moment(asset?.capturedDate).format('YYYY-MM-DD')}</StyledP>
                                <StyledP small><StyledB>Uploaded: </StyledB>{moment(asset?.createdAt).format('YYYY-MM-DD')}</StyledP>
                                <StyledP small><StyledB>Likes: </StyledB><TotalEngagement asset={asset} engagement="like" /></StyledP>
                                <StyledP small><StyledB>Saves: </StyledB><TotalEngagement asset={asset} engagement="save" /></StyledP>
                            </Stack>
                        </StyledTabPanel>

                    </SmartContainer>
                </StyledBody>
                {renderNavigation()}
            </StyledAssetContainer >
        </animated.div >
    )
}